/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { ListByPlatformConnectionQueryResponse, ListByPlatformConnectionPathParams } from "../models/ListByPlatformConnection";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listByPlatformConnection } from "../axios/listByPlatformConnection";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listByPlatformConnectionQueryKey = (platform: ListByPlatformConnectionPathParams["platform"]) => ["social-export-api", { url: '/connections/:platform', params: {platform:platform} }] as const

export type ListByPlatformConnectionQueryKey = ReturnType<typeof listByPlatformConnectionQueryKey>

export function listByPlatformConnectionQueryOptions(platform: ListByPlatformConnectionPathParams["platform"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listByPlatformConnectionQueryKey(platform)
        return queryOptions<ListByPlatformConnectionQueryResponse, ResponseErrorConfig<Error>, ListByPlatformConnectionQueryResponse, typeof queryKey>({
         enabled: !!(platform),
         queryKey,
         queryFn: async ({ signal }) => {
            return listByPlatformConnection(platform, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get all connection for a given platform
 * {@link /connections/:platform}
 */
export function useListByPlatformConnection<TData = ListByPlatformConnectionQueryResponse, TQueryData = ListByPlatformConnectionQueryResponse, TQueryKey extends QueryKey = ListByPlatformConnectionQueryKey>(platform: ListByPlatformConnectionPathParams["platform"], options: 
{
  query?: Partial<QueryObserverOptions<ListByPlatformConnectionQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? listByPlatformConnectionQueryKey(platform)
         

         const query = useQuery({
          ...listByPlatformConnectionQueryOptions(platform, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}